import Api from '../../shared/Api';
import {
    BookingRange,
    CalendarBroker,
    CancellationTiming,
    CustomerBooking,
    UnbookedOrders
} from './types';

export class CustomerCalendarApi {
    static async getBookings(range: BookingRange): Promise<CustomerBooking[]> {
        return new Api().get('/views/customer-calendar/bookings', range);
    }

    static async getUnbookedOrders(): Promise<UnbookedOrders> {
        return new Api().get('/views/customer-calendar/unbooked-orders');
    }

    static async getBrokers(): Promise<CalendarBroker[]> {
        return new Api().get('/views/customer-calendar/brokers');
    }

    static async precheckPhotoCancellation(
        calendarItemId: number
    ): Promise<{ bookingCancellationType: CancellationTiming }> {
        return new Api().get(`/views/photographer-booking/${calendarItemId}/precheck`);
    }

    static async cancelPhotoBooking(calendarItemId: number): Promise<unknown> {
        return new Api().delete(`/views/photographer-booking/${calendarItemId}`);
    }

    static async cancelStylingBooking(calendarItemId: number): Promise<unknown> {
        return new Api().delete(`/views/stylinguser-booking/${calendarItemId}`);
    }
}
